import React from 'react';
import { Typography, Link, Box, Grid } from '@mui/material';
import { typo } from '../../../assets/fonts/font';
import colorConfigs from '../../../configs/colorConfigs';

const RefundPrivacyPolicyPage = () => {
  return (
    <Box
      sx={{
        py: 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: colorConfigs.secondary,
      }}
    >
      <Typography sx={{ ...typo.title, fontWeight: 'bold', paddingBottom: 5 }}>
        Privacy Policy
      </Typography>

      <Grid container spacing={4} sx={{ maxWidth: '1200px', px: 2 }}>
        <Grid item xs={12}>
          <Typography sx={{ ...typo.bodyContent }}>
            Who We Are "We", "us" or "our" refers to Wholly Greens Pte. Ltd., doing business as NOMZY, a Singapore-based company headquartered at 5 Harrison Rd, #03-01 Yan Xian Building Singapore 369645. We are responsible for the personal data collected through your interaction with our website and act as the data controller.
            <br /><br />
            <strong>Purpose of This Policy</strong> We value your privacy and are committed to protecting your personal data. This Privacy Policy ("Policy") outlines how we collect, use, share, and safeguard the information you provide to us. Please read this Policy carefully.
            <br /><br />
            For any questions, concerns, or to exercise your data rights as outlined in Section 5, you may contact us at <Link href="mailto:hello@nomzy.club">hello@nomzy.club</Link>
            <br /><br />
            <em>This Policy was last updated on July 11, 2025.</em>
            <br /><br />
            <strong>Collection and Use of Personal Data</strong> Personal data refers to any information that can identify you as an individual, directly or indirectly. We collect personal data for the following purposes:
            <br /><br />
            • Responding to inquiries submitted through our contact form.<br />
            • Creating user profiles and processing transactions.<br />
            • Sending newsletters and updates if you register for them.<br />
            • Maintaining and improving our website, apps, advertising, and digital experience.<br />
            • Enforcing legal rights and complying with legal obligations.<br /><br />
            <strong>Types of data we collect include:</strong>
            <br /><br />
            <strong>Contact Information:</strong> Name, address, email, phone number, and any other details you submit via forms.<br />
            <strong>Profile Information:</strong> When you register, we may collect job title, company name, country, and industry.<br />
            <strong>Newsletter Subscriptions:</strong> Email address.<br />
            <strong>Transaction Details:</strong> Information about your purchases, payment methods, and billing details.<br />
            <strong>Identifiers:</strong> Sales inquiries, partnership requests, and newsletter sign-ups.<br />
            <strong>Age and Classification:</strong> To ensure legal access to our products and services.<br />
            <strong>Commercial History:</strong> Purchase and interaction history.<br />
            <strong>Internet Activity:</strong> IP address, device info, browser settings, geographic location, and on-site activity.<br />
            <strong>Geolocation Data:</strong> To comply with regional product regulations.<br />
            <strong>Employment Information:</strong> Used when deliveries are related to your workplace.<br />
            <strong>Preferences:</strong> Including taste or scent preferences.<br /><br />
            We only process your personal data where we have a valid legal basis, including your consent, contractual obligations, or our legitimate business interests.
            <br /><br />
            <strong>Disclosures for Business Purposes:</strong> We may share the following data with service providers for business needs:
            <br /><br />
            • Name and address for delivery logistics.<br />
            • Payment data for processing transactions.<br />
            • Age verification for compliance.<br />
            • Order information for order fulfillment.<br />
            • Internet usage for analytics.<br />
            • Location data for legal compliance.<br />
            • Work-related details for workplace deliveries.<br />
            • Consumer preferences for product relevance.<br /><br />
            You can withdraw your consent or object to our use of your data at any time by contacting <Link href="mailto:hello@nomzy.com">hello@nomzy.com</Link>.
            <br /><br />
            <strong>Data Retention and Deletion</strong> We retain your personal data only as long as necessary to:
            <br /><br />
            • Provide requested services or information.<br />
            • Fulfill contractual and legal obligations.<br />
            • Complete transactions and communicate with you.<br />
            • Operate interactive site features.<br />
            • Comply with laws or legal proceedings.<br /><br />
            If you withdraw your consent or request deletion, we will remove your data unless required for legal reasons or to uphold your preferences.
            <br /><br />
            <strong>Your Rights</strong> You have several rights under data protection laws:
            <br /><br />
            • <strong>Access:</strong> Request confirmation and a copy of your personal data.<br />
            • <strong>Correction:</strong> Request correction of inaccurate or incomplete data.<br />
            • <strong>Erasure:</strong> Request deletion of your data under specific circumstances.<br />
            • <strong>Restriction:</strong> Request temporary restriction of processing.<br />
            • <strong>Portability:</strong> Receive a copy of your data in a machine-readable format.<br />
            • <strong>Objection:</strong> Object to processing based on legitimate interests or for direct marketing.<br />
            • <strong>Non-Discrimination:</strong> You will not be discriminated against for exercising your rights.<br />
            • <strong>Complaint:</strong> File a complaint with a data protection authority.<br /><br />
            To exercise your rights, contact <Link href="mailto:hello@nomzy.club">hello@nomzy.club</Link>. We aim to respond within one month.
            <br /><br />
            <strong>Sharing with Third Parties</strong> We may share your personal data with third-party service providers for:
            <br /><br />
            • Hosting: e.g., Google Cloud.<br />
            • Legal obligations and vital interests.<br />
            • Social media plugin functionality only (e.g., Facebook, Instagram, TikTok, LinkedIn). These platforms may collect data when you interact with their plugins. Refer to their privacy policies for details.<br /><br />
            We do not sell your personal data.
            <br /><br />
            <strong>International Data Transfers</strong>
            <br /><br />
            If your personal data is transferred outside the U.S., we ensure proper safeguards are in place to protect your data.
            <br /><br />
            <strong>Cookies</strong>
            <br /><br />
            Our website uses cookies to improve your browsing experience. You can manage cookie preferences through your browser settings. For more details, see our Cookie Policy.
            <br /><br />
            <strong>Policy Updates</strong>
            <br /><br />
            We may revise this Privacy Policy occasionally. The latest version will always be available on our website.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RefundPrivacyPolicyPage;